import { useEffect } from 'react';

import {
  GATEWAYS_HEALTH_POLLING_INTERVAL_MS,
  useGatewaysHealthActions,
  useGatewaysHealthData,
} from '@/console/features/gateways/hooks/use-gateway-health/gateways-health-context';
import { usePollingQuery } from '@/shared/hooks/use-polling-query/use-polling-query';
import { useReadGatewayHealthStatusQuery } from '@/shared/redux/api/assets/gateways/gateways-api';

export const useGatewayHealth = (gatewayId?: string) => {
  const actions = useGatewaysHealthActions();
  const data = useGatewaysHealthData();
  const useProvider = actions !== null;

  useEffect(() => {
    if (!actions || !gatewayId) return;
    actions.register(gatewayId);
    return () => actions.unregister(gatewayId);
  }, [actions, gatewayId]);

  const { data: fallbackData, isLoading: fallbackLoading } = usePollingQuery({
    useQueryHook: useReadGatewayHealthStatusQuery,
    queryArg: {
      gatewayId,
    },
    pollingInterval: GATEWAYS_HEALTH_POLLING_INTERVAL_MS,
    queryOptions: { skip: !gatewayId || useProvider },
  });

  if (useProvider) {
    const entry = gatewayId ? data?.states[gatewayId] : undefined;
    return {
      state: entry?.state,
      reportedDate: entry?.reportedAt,
      isLoading: Boolean(data?.isLoading) && !entry,
    };
  }

  return {
    state: fallbackData?.readGatewayState?.state,
    reportedDate: fallbackData?.readGatewayState?.reportedAt,
    isLoading: fallbackLoading,
  };
};
